import httpClient from "./httpClient";

export const onApiCall = async ({
  method,
  url,
  data,
  params,
  isFileUpload = false,
  isPdf = false,
}) => {
  // const { resetClick } = useContext(Appcontext);

  const constructHeaders = () => {
    if (isFileUpload) {
      return {
        common: { "Content-Type": "multipart/form-data" },
      };
    } else if (isPdf) {
      return {
        common: { "Content-Type": "application/pdf" },
      };
    } else {
      return {
        common: { "Content-Type": "application/json" },
      };
    }
  };

  try {
    const response = await httpClient.request({
      url,
      method,
      data,
      params,
      headers: constructHeaders(),
    });
    const hasPayload =
      response.data &&
      typeof response.data === "object" &&
      Object.prototype.hasOwnProperty.call(response.data, "payload");

    return {
      data: hasPayload ? response.data.payload : response.data,
      status: response.status,
    };
  } catch (error) {
    if (error.response) {
      console.log("API Error Response:", error.response);
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      // if (error.response.status == 401) {
      //   resetClick();
      // }
      return {
        data: error.response.data.error ?? error.response.data,
        status: error.response.status,
      };
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the
      // browser and an instance of
      // http.ClientRequest in node.js
      return {
        data: "api error",
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        data: "api error",
      };
    }
  }
};
